import InvoiceForContactDatagrid from 'src/components/DatagridEntity/InvoiceForContactDatagrid';

const InvoicesContactPage = () => (<InvoiceForContactDatagrid />);
export default InvoicesContactPage;
